import { Divider } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { Line } from 'app/components/pages/GiftCards/details/Line/Line';
import type { BookingDetails } from 'app/typings/adminBookings/bookings';
import { parseUppercaseSnakeTextToCapitalize } from 'app/utils/string';
import { getVCCStatus, type BookingInfo } from 'app/utils/vcc';

import './VirtualCard.scss';

type VirtualCardProps = {
  bookingDetails: BookingDetails;
};

export const VirtualCard = ({ bookingDetails }: VirtualCardProps) => {
  const { currencyFormatter } = useContext(CurrencyContext);

  const bookingInfo: BookingInfo = {
    checkin: bookingDetails.bookingSummary.checkin,
    status: bookingDetails.bookingSummary.status,
    psp: bookingDetails.bookingSummary.psp,
    refunds: bookingDetails.refunds,
    hotelAmount: bookingDetails.bookingSummary.hotelAmount,
    issuingTransactionId: bookingDetails.bookingSummary.issuingTransactionId,
    issuingChargedAt: bookingDetails.bookingSummary.issuingChargedAt,
    issuingAuthorizationId:
      bookingDetails.bookingSummary.issuingAuthorizationId,
    vccStatus: bookingDetails.vccStatus,
    issuingTransactions: bookingDetails.issuingTransactions,
  };

  const status = getVCCStatus(bookingInfo, currencyFormatter);

  const shouldShowToCharge = bookingDetails.issuingBalance > 0;
  const shouldShowToRefund = bookingDetails.issuingBalance < 0;

  return (
    <div className="bloc virtual-card">
      <div className="title-with-button2">
        <div className="label">Virtual Card (VCC)</div>
      </div>
      <div className="generic-content">
        <Line
          title="VCC status"
          value={parseUppercaseSnakeTextToCapitalize(bookingDetails.vccStatus)}
        />
        <Line
          title="To charge"
          value={currencyFormatter(
            shouldShowToCharge ? bookingDetails.issuingBalance : 0
          )}
        />
        <Line
          title="To refund"
          value={currencyFormatter(
            shouldShowToRefund ? -bookingDetails.issuingBalance : 0
          )}
        />
        {!!status.history.length && (
          <>
            <Divider />
            <Line title="History" />
            <div className="history">
              {status.history.map((item, idx) => (
                <div key={idx}>{item}</div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
